import React from 'react';

import SvgIcon from '../SvgIcon';
import { direction, IconProps } from '../types';

interface CaretIconProps extends IconProps {
  direction?: direction;
}

const CaretIcon: React.FC<CaretIconProps> = ({ className, size, disabled, direction = 'up' }) => (
  <SvgIcon
    viewBox="0 0 20 20"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={1.5}
    stroke="currentColor"
    fill="none"
    direction={direction}
  >
    <path
      d="M3.75 12.5L10 6.25L16.25 12.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
      fill="none"
    ></path>
  </SvgIcon>
);

export default CaretIcon;
